/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Client_UpdateInputs */

const cs_audit_key_client_update = /** @type {(inputs: Audit_Key_Client_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klient upraven`)
};

const en_audit_key_client_update = /** @type {(inputs: Audit_Key_Client_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client updated`)
};

/**
* | output |
* | --- |
* | "Client updated" |
*
* @param {Audit_Key_Client_UpdateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_client_update = /** @type {((inputs?: Audit_Key_Client_UpdateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Client_UpdateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_client_update(inputs)
	return cs_audit_key_client_update(inputs)
});